/**
 * Enum that helps understand where the error originated from
 */
/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var Scenario;
(function (Scenario) {
    Scenario["GetAppliedLabel"] = "GetAppliedLabel";
    Scenario["GetIsProtectionEnabled"] = "GetIsProtectionEnabled";
    Scenario["GetIrmCapabilities"] = "GetIrmCapabilities";
    Scenario["GetWatermarking"] = "GetWatermarking";
    Scenario["SetLabel"] = "SetLabel";
    Scenario["RemoveLabel"] = "RemoveLabel";
    Scenario["GetDlpPolicyTip"] = "GetDlpPolicyTip";
    Scenario["ProcessPolicySettings"] = "ProcessPolicySettings";
    Scenario["EnforceInformationProtection"] = "EnforceInformationProtection";
    Scenario["EnforceMandatoryLabelExperience"] = "EnforceMandatoryLabelExperience";
})(Scenario || (Scenario = {}));
//# sourceMappingURL=Scenario.js.map